














import { Component, Vue, Prop, Watch, PropSync } from "vue-property-decorator";
import * as cropsService from "@/services/crops";
import { CropsDTO } from "@/api/crops/types";
import CropsTable from "./CropsTable.vue";
import HarvestDataEditor from "@/components/harvestDataEditor/HarvestDataEditor.vue";

@Component({
  name: "CropsTableController",
  components: {
    CropsTable,
    HarvestDataEditor,
  }
})
export default class CropsTableController extends Vue {
  @Prop({ type: String, default: "" }) 
  private farmAnalysisUuid!: string;

  @Prop({ type: String, default: "SUMMER" }) 
  private harvestSeason!: string;

  @Prop({ type: String, default: "SOY" }) 
  private cropType!: string;

  @Prop({ type: String, default: null }) 
  private hovered!: string | null;

  @Prop({ type: Boolean, default: false }) 
  private completed!: boolean;

  @PropSync('selected', { type: Array, default: () => [] }) 
  private selectedCrops!: string[];

  @Watch('completed', { immediate: true })
  private async onCompleted() {
    await this.getCrops(this.farmAnalysisUuid);
  }

  @Watch('harvestSeason', { immediate: true })
  private async seasonChanged() {
    await this.getCrops(this.farmAnalysisUuid);
  }

  private async mounted() {
    await this.getCrops(this.farmAnalysisUuid);
  }


  private get cropsList() {
    return this.$store.getters[`crops/crops`](this.farmAnalysisUuid);
  }

  private get selectedCropsData(): CropsDTO[] {
    const selected = new Set(this.selectedCrops.map(String));
    return (this.cropsList || [])
      .flat()
      .filter((crop: CropsDTO) => selected.has(String(crop.cropLabel)));
  }

  private async getCrops(farmAnalysisUuid: string) {
    // Ao não passar nenhum CROPT_TYPE, o endpoint retorna multicultura
    await cropsService.getCropsByFarmAnalysisUuid(farmAnalysisUuid, this.harvestSeason, undefined);
  }

  private onHarvestSaved() {
    // O recálculo de scores/summary é assíncrono; reconsulta após alguns segundos.
    setTimeout(() => {
      this.getCrops(this.farmAnalysisUuid);
    }, 4000);
  }
}
